import { MathProportionCalculator } from './proportion';
import { MathRandomizer } from './randomize';
import { MathPrecisionTool } from './precision';

export class MathUtils {
  public static precision = MathPrecisionTool;
  public static proportion = MathProportionCalculator;
  public static randomization = MathRandomizer;
}
